import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';

interface EventListButtonProps {
    onClick: () => void;
}

export const EventListButton = (props: EventListButtonProps) => {
    return (
        <button id="EventList" className="btn btn-primary" type="button" onClick={() => props.onClick()} onKeyDown={OnIgnoreEnter}>
            Events List&nbsp;
        </button>
    );
}
